import { Outlet, useLocation } from 'react-router';
import { Navbar } from '@/components/molecules/Navbar';
import { BottomNav } from '@/components/molecules/BottomNav';
import { PokemonsSubNav } from '@/components/molecules/PokemonsSubNav';

export const AppLayout = () => {
  const { pathname } = useLocation();
  // Animate only when switching between top-level sections (not within /pokemons/*)
  const rootSegment = pathname.split('/')[1];
  return (
    <div className="flex min-h-screen flex-col bg-page">
      <Navbar />
      <main
        key={rootSegment}
        className="min-h-0 flex-1 animate-[fadeInUp_0.25s_ease-out] pb-16 lg:pb-0"
      >
        <Outlet />
      </main>
      <BottomNav className="lg:hidden" />
    </div>
  );
};

export const PokemonsLayout = () => {
  const { pathname } = useLocation();
  return (
    <>
      <PokemonsSubNav />
      {/* Animate content on sub-route changes, SubNav stays stable */}
      <div key={pathname} className="animate-[fadeInUp_0.2s_ease-out]">
        <Outlet />
      </div>
    </>
  );
};
